import { LoginPage } from './login';
export { LoginPage };
export default LoginPage;
